import React, { useState } from "react";
import submit from "submit-form";
import Modal from "../../../../parts/modal-new";
import PropTypes from "prop-types";
import CopyMealPlanToWeekSelector from "../modal-components/CopyMealPlanToWeekSelector";
import CopyMealPlanToAthleteSelector from "../modal-components/CopyMealPlanToAthleteSelector";
import CopyMealPlanToPlanSelector from "../modal-components/CopyMealPlanToPlanSelector";
import ConfirmationModal from "../../../../parts/modals/ConfirmationModal";

const CopyMealPlanToModal = ({ locals }) => {
  const {
    mealPlanTemplates = [],
    assignedMealPlans = [],
    query,
    allAthletesFromOrganization = [],
    activeUser: { athletes = [], webAppTheme = "dark" },
  } = locals;
  const { templateId: mealPlanId = "", week } = query;

  const currentTemplate = mealPlanTemplates.find(
    ({ _id }) => _id === mealPlanId
  );
  const [state, setState] = useState({
    selectedWeeksByTemplate: {},
    selectedAthlete: null,
    step: week !== undefined && week !== null ? 2 : 1,
    selectedCurrentTemplateWeeks:
      week !== undefined && week !== null ? [week] : [],
    showConfirmationModal: false,
  });
  const {
    selectedWeeksByTemplate,
    selectedAthlete,
    step,
    selectedCurrentTemplateWeeks,
    showConfirmationModal,
  } = state;
  const updateState = (newValues) => {
    setState((prevState) => ({ ...prevState, ...newValues }));
  };

  /**
   * Send the information to the api
   */
  const handleCopy = () => {
    const filteredTemplates = Object.fromEntries(
      Object.entries(selectedWeeksByTemplate).filter(
        ([_, weeks]) => weeks.length > 0
      )
    );

    const url = `/actions/meal-planner/copy-to-from-meal-template`;

    const body = {
      fromPlanId: mealPlanId,
      handle: "to",
      fromSelectedWeeks: selectedCurrentTemplateWeeks,
      toPlans: filteredTemplates,
    };
    submit(url, {
      method: "POST",
      body,
    });
  };

  /**
   * Function to close the confirmation modal
   */
  const handleCancelModal = () => {
    updateState({
      showConfirmationModal: false,
    });
  };

  return (
    <Modal
      toClear={["templateId", "week"]}
      className="copy-meal-plan-to"
      title="Copy Meal Plan To"
    >
      <>
        {step === 1 ? (
          <CopyMealPlanToWeekSelector
            currentTemplate={currentTemplate}
            selectedCurrentTemplateWeeks={selectedCurrentTemplateWeeks}
            updateState={updateState}
          />
        ) : (
          <div className="body">
            <div>
              <CopyMealPlanToAthleteSelector
                assignedMealPlans={assignedMealPlans}
                athletes={athletes}
                allAthletesFromOrganization={allAthletesFromOrganization}
                updateState={updateState}
                webAppTheme={webAppTheme}
                selectedAthlete={selectedAthlete}
              />
            </div>
            <div>
              <CopyMealPlanToPlanSelector
                selectedWeeksByTemplate={selectedWeeksByTemplate}
                selectedCurrentTemplateWeeks={selectedCurrentTemplateWeeks}
                assignedMealPlans={assignedMealPlans}
                selectedAthlete={selectedAthlete}
                setState={setState}
              />
            </div>
          </div>
        )}

        {step === 1 ? (
          <footer>
            <button
              type="button"
              data-button-type="primary"
              disabled={selectedCurrentTemplateWeeks.length === 0}
              onClick={() => {
                updateState({
                  step: 2,
                  selectedWeeksByTemplate: {},
                });
              }}
            >
              Next
            </button>
          </footer>
        ) : (
          <footer>
            <button
              className="back"
              onClick={() => {
                updateState({
                  step: 1,
                });
              }}
            >
              Back
            </button>
            <button
              type="submit"
              data-button-type="primary"
              disabled={
                !Object.values(selectedWeeksByTemplate).some(
                  (weeks) => weeks.length > 0
                )
              }
              onClick={() => {
                updateState({
                  showConfirmationModal: true,
                });
              }}
            >
              Send
            </button>
          </footer>
        )}
        <ConfirmationModal
          isOpen={showConfirmationModal}
          title="Apply Changes"
          contentText="Applying this meal plan template will erase any foods you’ve already added."
          cancelButtonText="Cancel"
          cancelButtonAction={handleCancelModal}
          confirmButtonText="Apply"
          confirmButtonAction={handleCopy}
        />
      </>
    </Modal>
  );
};

CopyMealPlanToModal.propTypes = {
  locals: PropTypes.object,
};

export default CopyMealPlanToModal;
